<template>
  <div ref="map" class="map">
    <!--
    <SearchParamsBatch></SearchParamsBatch>
    -->
    <MyLegend></MyLegend>
    <SearchBox></SearchBox>
    <InfoPopup
      :isPrivate="isPrivate"
      @close="infoPopupClosed"
      :map="mapInstance"
      :features="selectedFeatures"
      :coordinate="clickCoordinate"
      :selectedID="selectedID"
    ></InfoPopup>
    <HoverInfo :map="mapInstance"></HoverInfo>
    <SoortSelector></SoortSelector>
  </div>
</template>
<script>
import { getMap, setTarget } from "../openlayers/olMap";
import MyLegend from "./Legend";
import SearchBox from "./SearchBox";
import InfoPopup from "./InfoPopup";
import SoortSelector from "./SoortSelector";
import SearchParamsBatch from "./SearchParamsBatch";
import HoverInfo from "./HoverInfo";
import Select from "ol/interaction/Select";
import { defaultSelectStyle } from "../openlayers/styles";
import { RESOLUTION_CLUSTER_BREAKPOINT } from "../openlayers/overlayLayers";
import paramsUtils from "../paramsUtils";

const multiSelect = new Select({
  multi: true,
  style: defaultSelectStyle,
});
const singelSelect = new Select({
  multi: false,
  style: defaultSelectStyle,
});

export default {
  components: {
    MyLegend,
    SearchBox,
    InfoPopup,
    SoortSelector,
    SearchParamsBatch,
    HoverInfo,
  },
  data() {
    return {
      mapInstance: null,
      data: {},
      selectedFeatures: [],
      clickCoordinate: [],
      selectedID: null,
    };
  },
  created() {
    let selectedIDParam = paramsUtils.parseHashBangArgs()["id"];
    const numberRegexp = /\d+/g;
    if (selectedIDParam) {
      if (selectedIDParam.startsWith("LS_ext_")) {
        this.selectedID = selectedIDParam;
      } else {
        selectedIDParam = selectedIDParam.toLowerCase();
        var match = selectedIDParam.match(numberRegexp);
        if (match && match.length) {
          if (match.length == 1) {
            this.selectedID = selectedIDParam.substring(0, 2) + "_" + match[0];
          } else {
            this.selectedID = selectedIDParam.substring(0, 2) + "_" + match[1];
          }
        }
      }
    }
  },
  mounted() {
    this.mapInstance = getMap();

    setTarget(this.$refs.map);

    getMap().addInteraction(singelSelect);
    getMap().addInteraction(multiSelect);
    multiSelect.setActive(false);
    this.mapInstance.getView().on("change:resolution", (e) => {
      if (e.oldValue) {
        singelSelect.setActive(RESOLUTION_CLUSTER_BREAKPOINT <= e.oldValue);
        multiSelect.setActive(RESOLUTION_CLUSTER_BREAKPOINT > e.oldValue);
      }
    });
    singelSelect.on("select", this.onFeatureSelect, this);
    multiSelect.on("select", this.onFeatureSelect, this);
  },
  beforeDestroy() {
    singelSelect.un("select", this.onFeatureSelect);
    multiSelect.un("select", this.onFeatureSelect);
    setTarget(null);
  },
  methods: {
    infoPopupClosed() {
      //this.selectedFeatures = [];
      multiSelect.getFeatures().clear();
      singelSelect.getFeatures().clear();
      this.selectedID = null;
      paramsUtils.clearHash();
    },
    onFeatureSelect(e) {
      console.log("select event");

      this.selectedFeatures = e.selected;
      if (e.selected.length > 0) {
        this.clickCoordinate = e.mapBrowserEvent.coordinate;
      } else {
        this.selectedID = null;
        paramsUtils.clearHash();
      }
    },
  },
  computed: {
    isPrivate() {
      return !this.$store.state.isPublicPage;
    },
  },
};
</script>
<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100%;
}
</style>
